"use client"

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { CustomEase } from "gsap/all"
import { MorphSVGPlugin } from "gsap/all"

import { css, fresponsive, styled } from "library/styled"
import { useRef } from "react"
import colors from "styles/colors"
import textStyles from "styles/text"
import type { AccordionData } from "."

gsap.registerPlugin(ScrollTrigger, CustomEase, MorphSVGPlugin)

export default function MobileFeatures({
	accordionData,
}: {
	accordionData: AccordionData[]
}) {
	const wrapperRef = useRef<HTMLDivElement | null>(null)

	return (
		<Wrapper ref={wrapperRef} data-header-hide>
			{accordionData.map((item) => {
				const {
					key,
					title,
					content,
					logo,
					colors: { primary, secondary, icon },
				} = item

				return (
					<AccordionItem className={key} key={title}>
						<AccordionContent>
							<Row>
								<AccordionTitle color={primary}>{title}</AccordionTitle>
								<AccordionIcon color={icon}>{logo}</AccordionIcon>
							</Row>

							<AccordionText color={secondary}>{content}</AccordionText>
						</AccordionContent>
						<AccordionImage>{item.image}</AccordionImage>
					</AccordionItem>
				)
			})}
		</Wrapper>
	)
}

const Wrapper = styled("div", {
	...fresponsive(css`
		width: 100%;
		height: auto;
		background-color: ${colors.offWhite};
		border: 1px solid ${colors.green100};
		border-bottom: none;
		border-radius: 24px 24px 0 0;
	`),
})

const AccordionItem = styled("div", {
	...fresponsive(css`
		position: relative;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	`),
})

const AccordionIcon = styled("div", ({ color }: { color: string }) => ({
	...fresponsive(css`
		width: 24px;
		height: 24px;
		color: ${color};
	`),
}))

const AccordionContent = styled("div", {
	...fresponsive(css`
		display: flex;
		flex-direction: column;
		gap: 24px;
		width: 100%;
		padding: 32px;
	`),
})

const AccordionTitle = styled("h1", ({ color }: { color: string }) => ({
	...fresponsive(css`
		${textStyles.bodyXL};
		color: ${color};
	`),
}))

const AccordionText = styled("p", ({ color }: { color: string }) => ({
	...fresponsive(css`
		${textStyles.bodyS};
		color: ${color};
		width: 287px;
	`),
}))

const AccordionImage = styled("div", {
	...fresponsive(css`
		width: 100%;
		height: 443px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	`),
})

const Row = styled("div", {
	...fresponsive(css`
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	`),
})
